import styled from "styled-components";


export const AgentWidgetContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background: ${props => props.theme.colors.white};
    padding: 0 15px;
`;

export const AgentWidgetContent = styled.div`
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    
    & > div {
        height: 100%;
        max-height: calc(100vh - 65px - 60px);
    }

    & > div > div {
        max-height: none;
        width: 100%;
    }

    .list-agents {
        height: 100%;
        
        & > div {
            height: 100%;
            max-height: none;
        }
    }
`;

export const AgentWidgetHeader = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SelectedAgentHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 16px 24px 16px 32px;
    gap: 16px;
    border-bottom: 1px solid ${props => props.theme.colors.clearGray};
    justify-content: space-between;
`;

export const BackButton = styled.button`
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.primary};
    width: 9.21px;
    height: 16px;
    
    &:hover {
        opacity: 0.8;
    }
`;

export const AgentInfo = styled.div`
    display: flex;
    align-items: center;
    margin-left: 8px;
`;

export const AgentAvatar = styled.div`
    width: 32px;
    height: 32px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SelectedAgentName = styled.span`
    font-weight: 500;
    font-size: 1rem;
    color: ${props => props.theme.colors.textPrimary};
`;

export const AgentInputWrapper = styled.div`
    width: 100%;
    margin-top: 16px;
`;

export const SelectedAgentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
`;

export const WidgetActions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    
    & > div {
        cursor: pointer;
    }
`;

export const TabsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    
    & > div:first-child > div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 9rem;
        border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
        font-family: ${(props) => props.theme.fonts.family.inter};
        font-size: 14px;
    }

    & > div:first-child > div > div {
        font-weight: normal;
        padding: 9px 0px;
    }

    & > div:last-child {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
`;

export const AgentActionsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    
    & > div {
        cursor:pointer;
    }
`
